type PasswordStrengthResult = {
  color: string;
  label: string;
  score: number;
};

type GetPasswordStrengthOptions = {
  password: string;
  emptyLabel: string;
  weakLabel: string;
  mediumLabel: string;
  strongLabel: string;
  veryStrongLabel: string;
};

const hasLetter = (value: string) => /[A-Za-zА-Яа-яЁё]/.test(value);
const hasDigit = (value: string) => /\d/.test(value);
const hasUpperAndLowerCase = (value: string) => /[A-ZА-ЯЁ]/.test(value) && /[a-zа-яё]/.test(value);
const hasSpecialCharacter = (value: string) => /[^A-Za-zА-Яа-яЁё0-9]/.test(value);

export const isPasswordValid = (value: string) =>
  value.length >= 8 && hasLetter(value) && hasDigit(value);

export const getPasswordStrength = ({
  password,
  emptyLabel,
  weakLabel,
  mediumLabel,
  strongLabel,
  veryStrongLabel,
}: GetPasswordStrengthOptions): PasswordStrengthResult => {
  if (!password) {
    return {
      color: '#9AA8C7',
      label: emptyLabel,
      score: 0,
    };
  }

  let score = 0;

  if (password.length >= 8) {
    score += 1;
  }

  if (hasLetter(password) && hasDigit(password)) {
    score += 1;
  }

  if (hasUpperAndLowerCase(password)) {
    score += 1;
  }

  if (hasSpecialCharacter(password) || password.length >= 12) {
    score += 1;
  }

  if (score <= 1) {
    return {
      color: '#D14343',
      label: weakLabel,
      score: 1,
    };
  }

  if (score === 2) {
    return {
      color: '#E58C2A',
      label: mediumLabel,
      score: 2,
    };
  }

  if (score === 3) {
    return {
      color: '#2E5AE8',
      label: strongLabel,
      score: 3,
    };
  }

  return {
    color: '#1F9D61',
    label: veryStrongLabel,
    score: 4,
  };
};
